module.exports = __webpack_public_path__ + "img/zhuanye-guanggao.d90817f9.svg";